import * as translation from "./de-DE.json";

export const translationDeDE = translation.default;
